import { Dispatch } from "redux";
import { PrimaryTableColumn } from "@hatch-digital-nl/abs-storybook/legacy";
import { EmployeeSortEnum } from "../../../common/enums/EmployeeSortEnum";
import { handleEmployeeSort } from "./handleEmployeeSort";

interface Args {
    sort: {
        sortName: string;
        isSorted: boolean;
    };
    dispatch: Dispatch;
}

export const getEmployeeTableHeadColumns = (
    args: Args,
): PrimaryTableColumn[] => {
    const { sort, dispatch } = args;

    return [
        {
            value: "Naam",
            isSortable: true,
            isSorted:
                sort.sortName === EmployeeSortEnum.NAME_DESC ||
                sort.sortName === EmployeeSortEnum.NAME_ASC,
            sortOnClick: handleEmployeeSort({
                sort: {
                    isSorted: sort.sortName === EmployeeSortEnum.NAME_DESC,
                    sortName: EmployeeSortEnum.NAME,
                },
                dispatch,
            }),
        },
        {
            value: "Medewerker ID",
            isSortable: false,
        },
        {
            value: "Functiegroep(en)",
            isSortable: true,
            isSorted: sort.sortName === EmployeeSortEnum.FUNCTION_GROUP_DESC,
            sortOnClick: handleEmployeeSort({
                sort: {
                    isSorted:
                        sort.sortName === EmployeeSortEnum.FUNCTION_GROUP_DESC,
                    sortName: EmployeeSortEnum.FUNCTION_GROUP,
                },
                dispatch,
            }),
        },
        {
            value: "Rol",
            isSortable: true,
            isSorted: sort.sortName === EmployeeSortEnum.ROLE_DESC,
            sortOnClick: handleEmployeeSort({
                sort: {
                    isSorted: sort.sortName === EmployeeSortEnum.ROLE_DESC,
                    sortName: EmployeeSortEnum.ROLE,
                },
                dispatch,
            }),
        },
        {
            value: "Status",
            isSortable: false,
        },
        {
            value: "Behaalde certificaten",
            isSortable: true,
            isSorted:
                sort.sortName === EmployeeSortEnum.ACHIEVED_CERTIFICATES_DESC,
            sortOnClick: handleEmployeeSort({
                sort: {
                    isSorted:
                        sort.sortName ===
                        EmployeeSortEnum.ACHIEVED_CERTIFICATES_DESC,
                    sortName: EmployeeSortEnum.ACHIEVED_CERTIFICATES,
                },
                dispatch,
            }),
        },
        {
            value: "Missende certificaten",
            isSortable: true,
            isSorted:
                sort.sortName === EmployeeSortEnum.MISSING_CERTIFICATES_DESC,
            sortOnClick: handleEmployeeSort({
                sort: {
                    isSorted:
                        sort.sortName ===
                        EmployeeSortEnum.MISSING_CERTIFICATES_DESC,
                    sortName: EmployeeSortEnum.MISSING_CERTIFICATES,
                },
                dispatch,
            }),
        },
        {
            value: "Binnenkort verlopende certificaten",
            isSortable: true,
            isSorted:
                sort.sortName === EmployeeSortEnum.EXPIRING_CERTIFICATES_DESC,
            sortOnClick: handleEmployeeSort({
                sort: {
                    isSorted:
                        sort.sortName ===
                        EmployeeSortEnum.EXPIRING_CERTIFICATES_DESC,
                    sortName: EmployeeSortEnum.EXPIRING_CERTIFICATES,
                },
                dispatch,
            }),
        },
    ];
};
